/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style7 = require("antd/lib/table/style");

var _table = require("antd/lib/table");

var _table2 = _interopRequireDefault(_table);

var _style8 = require("antd/lib/modal/style");

var _modal = require("antd/lib/modal");

var _modal2 = _interopRequireDefault(_modal);

var _jsx2 = require("babel-runtime/helpers/jsx");

var _jsx3 = _interopRequireDefault(_jsx2);

var _style9 = require("antd/lib/message/style");

var _message = require("antd/lib/message");

var _message2 = _interopRequireDefault(_message);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _style10 = require("antd/lib/button/style");

var _button = require("antd/lib/button");

var _button2 = _interopRequireDefault(_button);

var _style11 = require("antd/lib/form/style");

var _form = require("antd/lib/form");

var _form2 = _interopRequireDefault(_form);

var _style12 = require("antd/lib/input/style");

var _input = require("antd/lib/input");

var _input2 = _interopRequireDefault(_input);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _tpl = require("tpl");

var _tpl2 = _interopRequireDefault(_tpl);

require("./index.less");

var _reactRouter = require("react-router");

var _tool = require("util/tool");

var _config = require("util/config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = _input2.default.Search;
var FormItem = _form2.default.Item,
    TextArea = _input2.default.TextArea,
    ButtonGroup = _button2.default.Group;

var _ref = (0, _jsx3.default)(_input2.default, {
  placeholder: "\u6E20\u9053"
});

var _ref2 = (0, _jsx3.default)(TextArea, {
  placeholder: "\u63CF\u8FF0"
});

var _ref3 = (0, _jsx3.default)("span", {}, void 0, " \uFF5C ");

var Edit = function (_Component) {
  (0, _inherits3.default)(Edit, _Component);

  function Edit(props, context) {
    (0, _classCallCheck3.default)(this, Edit);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Edit.__proto__ || (0, _getPrototypeOf2.default)(Edit)).call(this, props, context));

    _this.state = {
      visible: false,
      default: (0, _extends3.default)({}, props.pass)
    };
    return _this;
  }

  (0, _createClass3.default)(Edit, [{
    key: "handleOk",
    value: function handleOk() {
      var _this2 = this;

      this.props.form.validateFields(function (err, values) {
        if (!err) {
          (0, _tool.http)(_config.apiJson.updateChannelInfoByChannelCode, (0, _extends3.default)({}, _this2.props.pass, values, {
            productId: _this2.props.params.id
          })).then(function (req) {
            if (req) {
              _message2.default.success("修改渠道成功");
              _this2.setState({
                visible: false
              });
              _this2.props.onLoad();
            }
          });
        }
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.setState({
        visible: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var formItemLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 1 }
      };
      var getFieldDecorator = this.props.form.getFieldDecorator;

      var defaults = (0, _extends3.default)({}, this.props.pass);
      return (0, _jsx3.default)("div", {
        className: "editSpan"
      }, void 0, (0, _jsx3.default)(_modal2.default, {
        title: "\u7F16\u8F91\u6E20\u9053",
        visible: this.state.visible,
        onOk: this.handleOk.bind(this),
        onCancel: this.handleCancel.bind(this)
      }, void 0, (0, _jsx3.default)("div", {}, void 0, (0, _jsx3.default)(_form2.default, {}, void 0, _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({}, formItemLayout, { label: "\u6E20\u9053" }),
        getFieldDecorator("channelName", {
          rules: [{
            required: true,
            message: "请输入渠道"
          }],
          initialValue: defaults.channelName
        })(_ref)
      ), _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({}, formItemLayout, { label: "\u63CF\u8FF0" }),
        getFieldDecorator("remark", {
          rules: [{
            required: false,
            message: "请输入渠道描述"
          }],
          initialValue: defaults.remark
        })(_ref2)
      )))), (0, _jsx3.default)("span", {
        onClick: function onClick() {
          _this3.setState({
            visible: true
          });
        }
      }, void 0, "\u7F16\u8F91"), _ref3, (0, _jsx3.default)("span", {
        onClick: function onClick() {
          _modal2.default.confirm({
            title: "\u786E\u8BA4\u5220\u9664" + _this3.state.default.channelName + "\u6E20\u9053\uFF1F",
            okText: "确认",
            cancelText: "取消",
            onOk: function onOk() {
              (0, _tool.http)(_config.apiJson.deleteChannelInfo, {
                channelCode: _this3.state.default.channelCode
              }).then(function (req) {
                _this3.props.onLoad();
              });
            }
          });
        }
      }, void 0, "\u5220\u9664"));
    }
  }]);
  return Edit;
}(_react.Component);
// 预返回表单


var Forms = _form2.default.create()((0, _reactRouter.withRouter)(Edit));

var _ref4 = (0, _jsx3.default)(_input2.default, {
  placeholder: "\u6E20\u9053"
});

var _ref5 = (0, _jsx3.default)(TextArea, {
  placeholder: "\u8BF7\u8F93\u5165\u6E20\u9053\u63CF\u8FF0"
});

var Main = function (_Component2) {
  (0, _inherits3.default)(Main, _Component2);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this4.state = {
      columns: [],
      dataSource: [],
      add: false,
      default: {}
    };
    return _this4;
  }

  (0, _createClass3.default)(Main, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.init();
    }
  }, {
    key: "init",
    value: function init() {
      var _this5 = this;

      var params = this.props.params;
      // 请求所有部件

      (0, _tool.http)(_config.apiJson.getChannelInfoListByProductId, {
        productId: params.id
      }).then(function (req) {
        _this5.setState({
          dataSource: req.map(function (mp) {
            return (0, _extends3.default)({}, mp);
          })
        });
      });
    }
  }, {
    key: "handleOks",
    value: function handleOks() {
      var _this6 = this;

      this.props.form.validateFields(function (err, values) {
        if (!err) {
          (0, _tool.http)(_config.apiJson.insertChannelInfo, (0, _extends3.default)({
            productId: _this6.props.params.id
          }, values)).then(function (req) {
            if (req) {
              _message2.default.success("增加渠道成功");
              _this6.setState({
                add: false,
                default: {
                  remark: ""
                }
              });
              _this6.init();
              _this6.props.form.resetFields();
            }
          });
        }
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.setState({
        default: {
          remark: ""
        },
        add: false
      });
      this.props.form.resetFields();
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var formItemLayout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 18, offset: 1 }
      };
      var getFieldDecorator = this.props.form.getFieldDecorator;


      var columns = [{
        title: "渠道",
        dataIndex: "channelName",
        key: "channelName"

      }, {
        title: "渠道代码",
        dataIndex: "channelCode",
        key: "channelCode"
      }, {
        title: "设备总数",
        dataIndex: "deviceCount",
        key: "deviceCount"
      }, {
        title: "描述",
        dataIndex: "remark",
        key: "remark"
      }, {
        title: "操作",
        dataIndex: "edit",
        key: "edit",
        render: function render(text, record) {
          return (0, _jsx3.default)(Forms, {
            pass: record,
            onLoad: _this7.init.bind(_this7)
          });
        }
      }];
      return (0, _jsx3.default)("div", {
        className: "channel"
      }, void 0, (0, _jsx3.default)(_modal2.default, {
        title: "\u65B0\u589E\u6E20\u9053",
        visible: this.state.add,
        onOk: this.handleOks.bind(this),
        onCancel: this.handleCancel.bind(this)
      }, void 0, (0, _jsx3.default)(_form2.default, {}, void 0, _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({}, formItemLayout, { label: "\u6E20\u9053" }),
        getFieldDecorator("channelName", {
          rules: [{
            required: true,
            message: "请输入渠道"
          }],
          initialValue: this.state.default.channelName
        })(_ref4)
      ), _react2.default.createElement(
        FormItem,
        (0, _extends3.default)({}, formItemLayout, { label: "\u63CF\u8FF0" }),
        getFieldDecorator("remark", {
          rules: [{
            required: false,
            message: "请输入渠道描述"
          }],
          initialValue: this.state.default.remark
        })(_ref5)
      ))), (0, _jsx3.default)("div", {
        className: "channelLine"
      }, void 0, (0, _jsx3.default)(_button2.default, {
        onClick: function onClick() {
          _this7.setState({
            add: true
          });
        }
      }, void 0, "\u65B0\u589E"), (0, _jsx3.default)(Search, {
        style: { float: "right", width: "200px", marginRight: "16px" },
        placeholder: "\u6E20\u9053\u540D\u79F0\u641C\u7D22",
        enterButton: "\u641C\u7D22",
        size: "large",
        onSearch: function onSearch(value) {
          value == '' ? _this7.init() : (0, _tool.http)(_config.apiJson.getChannelInfoByChannelName, {
            channelName: value,
            productId: _this7.props.params.id
          }).then(function (req) {
            if (req) {
              _this7.setState({
                dataSource: [req]
              });
            } else {
              _this7.setState({
                dataSource: []
              });
              _message2.default.warning("无相应数据");
            }
          });
        }
      })), (0, _jsx3.default)(_table2.default, {
        pagination: false,
        dataSource: this.state.dataSource,
        columns: columns,
        className: "list"
      }));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _tpl2.default)({
  component: _form2.default.create()((0, _reactRouter.withRouter)(Main)) // 接收数据的组件入口
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/channel/index.jsx
// module id = 1544
// module chunks = 0